import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import SignaturePad from '../../sigpad/signature_pad';
import { resizeCanvas } from '../../sigpad/sigpad_util';
import { updateCanvasSize } from '../image-edit-util';

@Component({
  selector: 'app-image-edit',
  templateUrl: './image-edit.component.html',
})
export class ImageEditComponent {

  signPad: SignaturePad | null = null;

  private canvasElem?: ElementRef;
  @ViewChild('signCanvas') set signCanvas(elem: ElementRef) {
    this.canvasElem = elem;

    this.signPad = updateCanvasSize(elem, this._canvasOptions);

    this.loadData();
  }

  _blockStyle: any = {};
  @Input('block-style') set blockStyle(style: any) {
    this._blockStyle = style;
  }

  _canvasStyle: any = {};
  @Input('canvas-style') set canvasStyle(style: any) {
    this._canvasStyle = style;
  }

  _canvasOptions: any = {};
  @Input('canvas-options') set canvasOptions(options: any) {
    this._canvasOptions = options;

    if (this.canvasElem) {
      this.signPad = updateCanvasSize(this.canvasElem, this._canvasOptions);

      this.loadData();
    }
  }

  _data: any = '';
  @Input('data') set data(data: any) {
    this._data = data;
    this.loadData();
  }

  _cleanBtnStyle: any = 'clear-button-default-style';
  @Input('clear-btn-style') set cleanBtnStyle(style: any) {
    this._cleanBtnStyle = style;
  }

  _name: any = '';
  @Input('name') set name(name: any) {
    this._name = name;
  }

  @Output('clear') clearEvent = new EventEmitter();

  clear() {
    const pad = this.signPad;
    if (pad) {
      pad.clear();
    }
  }

  clearClick() {
    this.clearEvent.emit(this._name);
  }

  loadData() {
    const pad = this.signPad;
    if (pad && this._data) {
      pad.fromDataURL(this._data);
    }
  }

  resizeCanvas() {
    const canv = this.canvasElem?.nativeElement;
    canv && resizeCanvas(canv, this.signPad);
  }

  toDataURL(): string | null {
    const pad = this.signPad;

    if (pad) {
      return pad.isEmpty() ? '' : pad.toDataURL();
    }
    return null;
  }
}
